// Plain text log parser
// Treats every line as a simple log entry with no structure

import { LogEntry } from './types';

let logIdCounter = 0;

/**
 * Create a plain text parser that treats every line as a standalone entry
 */
export function createPlainTextParser(sourceId?: string) {
  return {
    /**
     * Parse a line and return it as a plain text entry
     */
    parseLine(rawLine: string, blockTimestamp?: Date): LogEntry[] {
      if (!rawLine.trim()) {
        return []; // Skip empty lines
      }

      const entry: LogEntry = {
        id: `${sourceId || 'default'}-${++logIdCounter}`,
        timestamp: blockTimestamp || new Date(),
        originalLine: rawLine,
        message: rawLine,
        category: undefined,
        thread: undefined,
        level: undefined,
        source: sourceId,
        isMultiLine: false,
      };

      return [entry];
    },

    /**
     * Flush any pending entry (no-op for plain text parser)
     */
    flush(): LogEntry[] {
      return [];
    },

    /**
     * Reset parser state (no-op for plain text parser)
     */
    reset() {
      // Nothing to reset
    },
  };
}
